module.exports = __webpack_public_path__ + "static/media/intro.2f85a4f2.mp3";